import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "keen-slider/keen-slider.min.css";
import styled from "@emotion/styled";
import { Trans } from "@lingui/react";
import { colors } from "../theme";
import { Warning, Error, DeletedProduct } from "../icons";
import { Fragment } from "react";
import { PriceView } from "./PriceView";
export function CardCarousel({ cardWidth, colorTexts, subelement, typographyTexts, isMobile, isSliderActive, context, }) {
    const deletedProduct = subelement.identifier.includes("deleted");
    const stockIndicatorPosition = deletedProduct || (subelement.status != null && subelement.status === "PA");
    return (_jsx(Card, Object.assign({ className: isSliderActive ? "keen-slider__slide" : "", isSliderActive: isSliderActive, cardWidth: cardWidth, isDesktop: !isMobile, deletedProduct: deletedProduct, context: context, style: { maxWidth: !isMobile ? "22.4rem" : "unset" }, "data-testid": `product-card-${subelement.identifier}` }, { children: _jsxs(Link, Object.assign({ href: subelement.url }, { children: [_jsxs(ImagesWrapper, Object.assign({ isDesktop: !isMobile }, { children: [subelement.status != null && subelement.status === "PA" && (_jsxs(Alert, Object.assign({ isMobile: isMobile, deletedProduct: deletedProduct }, { children: [_jsx(Warning, {}, void 0),
                                _jsxs(AlertTextContainer, { children: [_jsxs(AlertTitle, Object.assign({ isMobile: isMobile }, { children: [isMobile ? (_jsx(Trans, { id: "Pausado" }, void 0)) : (_jsx(Trans, { id: "Producto Pausado" }, void 0)), " "] }), void 0),
                                        !isMobile && (_jsx(AlertText, { children: _jsx(Trans, { id: "Tus compradores no van a verlo" }, void 0) }, void 0))] }, void 0)] }), void 0)),
                        deletedProduct && (_jsxs(Alert, Object.assign({ isMobile: isMobile, deletedProduct: deletedProduct }, { children: [_jsx(Error, {}, void 0), " ", _jsxs(AlertText, { children: [isMobile ? (_jsx(Trans, { id: "Eliminado" }, void 0)) : (_jsx(Trans, { id: "Producto eliminado" }, void 0)), " "] }, void 0)] }), void 0)),
                        subelement.has_stock != null && !subelement.has_stock && (_jsx(StockIndicator, Object.assign({ indicatorPosition: stockIndicatorPosition }, { children: _jsx(StockText, { children: _jsx(Trans, { id: "Sin stock" }, void 0) }, void 0) }), void 0)),
                        deletedProduct ? (_jsx(DeletedProductContainer, { children: _jsx(DeletedProductStyled, { isMobile: isMobile }, void 0) }, void 0)) : (_jsx(Images, { alt: subelement.name, src: subelement.image.thumbnails[isMobile ? "small" : "medium"] }, subelement.identifier))] }), void 0),
                _jsx(TextContainer, Object.assign({ isDesktop: !isMobile }, { children: deletedProduct ? (_jsxs(Fragment, { children: [_jsx(DeletedPlaceholderText, { isMobile: isMobile, width: "100%" }, void 0),
                            _jsx(DeletedPlaceholderText, { isMobile: isMobile, width: "70%" }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [" ", _jsx(Title, Object.assign({ colorTexts: colorTexts, typographyTexts: typographyTexts, isDesktop: !isMobile }, { children: subelement.name }), void 0),
                            _jsxs(PriceContainer, { children: [subelement.min_price !== subelement.max_price && (_jsxs(Text, Object.assign({ colorTexts: colorTexts, typographyTexts: typographyTexts, isDesktop: !isMobile }, { children: [_jsx(Trans, { id: "Desde" }, void 0), " \u00A0 "] }), void 0)),
                                    _jsx(Price, Object.assign({ colorTexts: colorTexts, typographyTexts: typographyTexts, isDesktop: !isMobile }, { children: _jsx(PriceView, { id: "price", price: formatPrice(subelement.min_price, subelement.language), locale: subelement.language }, void 0) }), void 0)] }, void 0)] }, void 0)) }), void 0)] }), void 0) }), subelement.identifier));
}
function formatPrice(price, language) {
    const adjustedPrice = price / 100;
    return adjustedPrice.toLocaleString(language, {
        maximumFractionDigits: Number.isInteger(adjustedPrice) ? 0 : 2,
        minimumFractionDigits: Number.isInteger(adjustedPrice) ? 0 : 2,
    });
}
const Card = styled.article(({ isSliderActive, cardWidth, isDesktop, deletedProduct, context }) => (Object.assign({ borderRadius: 4, boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.23)", backgroundColor: deletedProduct ? colors.greyLightest : colors.white, minHeight: isSliderActive ? (cardWidth / 60) * 89 : "26.8rem", width: context === "editor" ? "15.5rem" : isSliderActive ? "unset" : "18rem", display: "grid", gridTemplateColumns: isSliderActive ? "unset" : "18rem", gridTemplateRows: `${isSliderActive ? cardWidth + "px" : "18rem"} 31%`, maxWidth: context === "editor" ? "15.5rem" : "18rem" }, (isDesktop
    ? {
        display: "block",
        maxWidth: "22.4rem",
        minHeight: "32.8rem",
        width: "22.4rem",
        "&:hover": {
            boxShadow: "0px 6px 12px 0px rgba(0,0,0,0.2)",
        },
    }
    : {}))));
const TextContainer = styled.div(({ isDesktop }) => `
  --titleFontSize: ${isDesktop ? "1.6rem" : "1.2rem"};
  --titleLineHeight: 1.2;
  --titleLineClamp: 2;
  --titleMaxHeight: calc(
    (var(--titleFontSize) * var(--titleLineHeight)) * var(--titleLineClamp)
  );
  border-top: 1px solid ${colors.greyMainLight};
  display: grid;
  grid-template-rows: var(--titleMaxHeight) 2.4rem;
  gap: 0.8rem;
  width: 100%;
  height: ${isDesktop ? "100%" : "auto"};
  padding: ${isDesktop ? "2.4rem 1.6rem" : "1.6rem"};
`);
const Title = styled.h2(({ typographyTexts, colorTexts, isDesktop }) => `
    margin: 0;
    color: ${colorTexts};
    font-family: ${typographyTexts};
    font-size: var(--titleFontSize);
    font-weight: 500;
    line-height: var(--titleLineHeight);
    display: -webkit-box;
    -webkit-line-clamp: var(--titleLineClamp);
    -webkit-box-orient: vertical;
    height: 100%;
    max-height: var(--titleMaxHeight);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  `);
const PriceContainer = styled.div(() => ({
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
}));
const Price = styled.span(({ typographyTexts, colorTexts, isDesktop }) => (Object.assign({ color: colorTexts, fontFamily: typographyTexts, fontSize: "1.4rem", fontWeight: "bold", "& sup": {
        fontSize: "1.2rem",
    } }, (isDesktop
    ? {
        fontSize: "1.8rem",
    }
    : {}))));
const Text = styled.span(({ typographyTexts, colorTexts, isDesktop }) => (Object.assign({ color: colorTexts, fontFamily: typographyTexts, fontSize: "1.2rem" }, (isDesktop
    ? {
        fontSize: "1.4rem",
    }
    : {}))));
const ImagesWrapper = styled.div(({ isDesktop }) => (Object.assign({ width: "100%", height: "100%", position: "relative", borderRadius: "4px 4px 0px 0px" }, (isDesktop
    ? {
        height: "22.4rem",
    }
    : {}))));
const Images = styled.img(() => ({
    backgroundColor: colors.white,
    borderRadius: "4px 4px 0px 0px",
    height: "100%",
    objectFit: "contain",
    width: "100%",
}));
const Link = styled.a(() => ({
    cursor: "pointer",
    height: "100%",
    width: "100%",
    textDecoration: "none",
}));
const Alert = styled.div(({ isMobile, deletedProduct }) => ({
    alignItems: "center",
    backgroundColor: deletedProduct ? colors.redLighter : colors.yellowLighter,
    borderColor: deletedProduct ? colors.redMain : colors.yellowMain,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: deletedProduct ? 1 : 4,
    display: "grid",
    gridGap: "1.6rem",
    gridTemplateColumns: "auto 1fr",
    height: isMobile ? "3.6rem" : "auto",
    margin: isMobile ? "0.8rem" : "1.2rem",
    padding: isMobile || deletedProduct ? "0.8rem" : "1.2rem",
    position: "absolute",
    zIndex: 1,
    width: "90%",
    "& svg": {
        alignSelf: "center",
        color: deletedProduct ? colors.redMain : colors.yellowMain,
        fontSize: isMobile ? "2rem" : "2.4rem",
    },
}));
const AlertTextContainer = styled.div({});
const AlertText = styled.p({
    fontFamily: "Open Sans, sans-serif",
    color: colors.greyDark,
    fontSize: "1.4rem",
    margin: 0,
    padding: 0,
});
const AlertTitle = styled(AlertText)(({ isMobile }) => ({
    fontWeight: isMobile ? "normal" : 600,
    padding: isMobile ? 0 : "0px 0px 4px",
}));
const StockIndicator = styled.div(({ indicatorPosition }) => (Object.assign({ backgroundColor: colors.greyDark, borderRadius: 4, height: "2.4rem", margin: "0.8rem", padding: "0.4rem 0.8rem", position: "absolute", textAlign: "center", width: "7.2rem" }, (indicatorPosition
    ? {
        bottom: 0,
    }
    : {
        top: 0,
    }))));
const StockText = styled.p({
    fontFamily: "Open Sans, sans-serif",
    color: colors.white,
    fontSize: "1.2rem",
    margin: 0,
    padding: 0,
});
const DeletedProductContainer = styled.div({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
});
const DeletedProductStyled = styled(DeletedProduct)(({ isMobile }) => ({
    fontSize: isMobile ? "7.2rem" : "8.4rem",
}));
const DeletedPlaceholderText = styled.div(({ width, isMobile }) => ({
    backgroundColor: colors.greyMainLight,
    height: isMobile ? "1.6rem" : "2rem",
    width: width,
}));
//# sourceMappingURL=CardCarousel.js.map